export enum InstructorRole {
    Instructor,
    Leader,
    Superior
}

export interface Instructor {
    Id?: string;
    Name: string,
    Surname: string,
    Gender: string,
    Password: string,
    Email: string,
    PhoneNumber: string,
    Pesel: string,
    DateOfBirth: string,
    MotherName: string,
    MotherSurname: string,
    FatherName: string,
    Street: string,
    BuildingNumber: string,
    FlatNumber: string,
    PostCode: string,
    City: string,
    RodoAccept: string
    InstructorRole?: InstructorRole
}